import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'view-design'
import BaiduMap from 'vue-baidu-map'
import { Lazyload } from 'vant'
// 引入全局样式
// import 'view-design/dist/styles/iview.css'
import './assets/theme/color.less'
import './assets/css/style.css'

Vue.use(iView)
Vue.use(Lazyload)
Vue.use(BaiduMap, { ak: 'RhuIto4XXpXyu8rgL1tiyhgq' })
Vue.config.productionTip = false
Vue.directive('title', { // 动态修改网页title
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
